// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__IZjTk","link":"HeaderSimple_link__EikVJ"};